module.exports = __webpack_public_path__ + "media/images/lb/989-ccab828baf9d4d58605d5c8ac2390553.svg";